import React from "react";
import OrderEditor from "@widgets/pos/order/OrderEditor";
import {useParams} from "react-router-dom";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {api} from "@/data/api";
import {useQuery} from "@tanstack/react-query";
import LoadingScreen from "@widgets/pos/layout/LoadingScreen";
import {EmptyState, Icon} from "peggirkit";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";


const PosOrder = () => {
    const {publicCartId} = useParams();
    const {dashboardLocation} = useRestaurant();
    const {data, isPending, isError} = useQuery({
        queryKey: ["pos-order-edit", dashboardLocation.id, publicCartId],
        queryFn: () => api.orders.getOrderForEdit(dashboardLocation.id, publicCartId!),
        enabled: publicCartId !== undefined,
        staleTime: 0,
        gcTime: 0,
    });

    if (publicCartId === undefined) {
        return <OrderEditor key={"new"}/>;
    }

    if (isPending) {
        return <LoadingScreen/>;
    }

    if (isError) {
        return (
            <div className={"w-full h-full flex items-center justify-center p-3"}>
                <EmptyState
                    icon={<Icon icon={ExclamationCircleIcon}/>}
                    title={<FormattedMessage id={"cannotLoadOrder"}/>}
                    description={<FormattedMessage id={"cannotLoadOrderDescription"}/>}
                />
            </div>
        );
    }

    return (
        <OrderEditor
            key={publicCartId}
            publicCartId={publicCartId}
            initialOrder={data}
        />
    );
};

export default PosOrder;